var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0274 21.1747L7.14034 20.0914L2 24H28.9829V17.6119L21.5632 15.6819L14.0274 21.1747Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3076 11.0997H3.2998V12.7396H11.3076V11.0997Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3716 7.94619H3.2998V9.58608H13.3716V7.94619Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10528 4.79222H3.4502V6.43211H9.10528V4.79222Z",
    fill: "#4D4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3763 4.5H19.7529V12.6953H21.3763V4.5Z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8934 6.48104H22.2715V12.6977H23.8934V6.48104Z",
    fill: "#4D4D4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7464 6.48104H17.123V12.6977H18.7464V6.48104Z",
    fill: "#4D4D4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4828 4.5H24.8594V12.6953H26.4828V4.5Z",
    fill: "#4D4D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 6.48104H27.3779V12.6977H28.9999V6.48104Z",
    fill: "#4D4D4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDados);
export default __webpack_public_path__ + "static/media/dados.e218ded4.svg";
export { ForwardRef as ReactComponent };